import { render } from "./DashboardPanelFunnel.vue?vue&type=template&id=15cd5fb4&scoped=true"
import script from "./DashboardPanelFunnel.vue?vue&type=script&lang=js"
export * from "./DashboardPanelFunnel.vue?vue&type=script&lang=js"

import "./DashboardPanelFunnel.vue?vue&type=style&index=0&id=15cd5fb4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cd5fb4"]])

export default __exports__